import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { headingMedium, headingSmall } from './Typography';
export const guidaTheme = {
    ...SkapaTheme,
    breakpoint: {
        ...SkapaTheme.breakpoint,
        small: {
            ...SkapaTheme.breakpoint.small,
            fontStyle: {
                ...SkapaTheme.breakpoint.small.fontStyle,
                headingSmall,
                headingMedium
            }
        },
        medium: {
            ...SkapaTheme.breakpoint.medium,
            fontStyle: {
                ...SkapaTheme.breakpoint.medium.fontStyle,
                headingSmall,
                headingMedium
            }
        },
        large: {
            ...SkapaTheme.breakpoint.large,
            fontStyle: {
                ...SkapaTheme.breakpoint.large.fontStyle,
                headingSmall,
                headingMedium
            }
        },
        xlarge: {
            ...SkapaTheme.breakpoint.xlarge,
            fontStyle: {
                ...SkapaTheme.breakpoint.xlarge.fontStyle,
                headingSmall,
                headingMedium
            }
        },
        xxlarge: {
            ...SkapaTheme.breakpoint.xxlarge,
            fontStyle: {
                ...SkapaTheme.breakpoint.xxlarge.fontStyle,
                headingSmall,
                headingMedium
            }
        }
    }
};
export * from './constants';
//# sourceMappingURL=index.js.map